import { datadogRum } from '@datadog/browser-rum';
import { featureFlagSlugs } from '@/constants/featureFlagSlugs';
import { useFeatureFlagsStore } from '@/stores/useFeatureFlags';
import useAcvDatadog from '@/composables/useAcvDatadog';

export default defineNuxtRouteMiddleware(async (to) => {
  // possibly cache user details to avoid a call on every page
  const featureFlagsStore = useFeatureFlagsStore();
  const isMagicLinkLoginEnabled = featureFlagsStore.getByFlagName(
    featureFlagSlugs.transportMagicLinkLogin,
  );
  if (isMagicLinkLoginEnabled) {
    return;
  }

  if (to.fullPath !== '/manage-jobs') {
    const { data, error } = await useAcvFetch(`api/user/userdetails`);
    const errorStatusCode = error.value ? error.value.statusCode : null;

    if (errorStatusCode) {
      return handleErrorStatusCode(errorStatusCode);
    }

    const userData = data?.value?.data;

    const userStateNavigation = handleUserState(userData);
    if (userStateNavigation) {
      return userStateNavigation;
    }

    if (data.value) {
      const userProcessingNavigation = processUserData(userData);
      if (userProcessingNavigation) {
        return userProcessingNavigation;
      }
    }
  }
});

const handleErrorStatusCode = (errorStatusCode) => {
  switch (errorStatusCode) {
    case 409:
      return navigateTo('/409');
    case 404:
    case 401:
      return navigateTo('/signup');
    case 500:
      return navigateTo('/something-went-wrong');
  }
};

const handleUserState = (userData) => {
  if (userData?.role === 'New') {
    return navigateTo('/account-pending');
  }

  if (!userData?.termsAccepted) {
    return navigateTo('/legal');
  }

  return null;
};

const processUserData = (userData) => {
  const { addRumError } = useAcvDatadog();
  if (useIsRestrictedUser({ ...userData })) {
    addRumError('403 error from validateUserRole');

    return navigateTo('/403', { query: { src: 'middleware' } });
  }

  const postalCode = userData?.carrier?.postalCode || '';
  sessionStorage.setItem('postalCode', JSON.stringify(postalCode));
  localStorage.setItem('user', JSON.stringify({ data: userData }));

  if (import.meta.env.PROD) {
    datadogRum.setUser({ id: userData.id, ...userData });
  }

  return null;
};
